import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const BoardStore = {
  namespaced: true,
  state: {
    isLoading: false,
    allConfigs: {},
    projectId: null,
    highlightOverdue: false,
    allFields: [],
    contextMenus: [],
    nameEditTaskKey: null,
    taskCardEditing: false,
    settingsTaskId: null,
    newTasksPool: [],
    customSort: [],
    datesWidth: 180
  },
  getters,
  mutations,
  actions,
};

export default BoardStore;
